export default "__VITE_ASSET__ez0HkoWF__"